
import React from 'react'
import { mdx } from '@mdx-js/react'

/* @jsxRuntime classic */
/* @jsx mdx */



const layoutProps = {
  
};
const MDXLayout = "wrapper"
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <p><em parentName="p">{`Où est-il utilisé?`}</em></p>
    <p>{`Des essais cliniques de phase III ont débuté en Allemagne en décembre 2020.
Après des résultats décevants (voir dans la catégorie "quelle est son
efficacité?"), Curevac a développé une version de deuxième génération plus
puissante. Appelée CV2CoV, elle génère une réponse immunitaire plus élevée chez
les animaux.`}</p>
    </MDXLayout>;
}

;
MDXContent.isMDXComponent = true;